import { ref } from 'vue';

export const useJSONUpload = () => {
  const jsonData = ref<object | null>(null);

  const handleFileUpload = (file: File) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        jsonData.value = JSON.parse(e.target?.result as string);
      } catch (error) {
        console.error('Błąd podczas parsowania pliku JSON:', error);
      }
    };

    reader.onerror = () => {
      console.error('Błąd podczas czytania pliku.');
    };

    reader.readAsText(file);
  };

  return {
    jsonData,
    handleFileUpload,
  };
};
